<div>
    <div id="chart-{{graph.code}}" style="display: block;">
        <canvas baseChart
            [data]="datatimes"
            [labels]="labels"
            [options]="options"
            [colors]="colors"
            [legend]="legend"
            chartType="line"
            [plugins]="plugins">
        </canvas>
    </div>
</div>
